export function messageReplyTarget(message) {
    const target = message?.reply_target
    if (message?.kind !== 'message' || !target || !Number.isSafeInteger(Number(target.id)) ||
        Number(target.id) < 1 || !['active', 'archive'].includes(target.source) ||
        !Number.isSafeInteger(Number(target.company_platform_id)) || Number(target.company_platform_id) < 1) return null
    return {
        id: Number(target.id),
        source: target.source,
        company_platform_id: Number(target.company_platform_id),
    }
}

export function replyTargetError(reply, channel) {
    if (!reply) return ''
    if (Number(reply.company_platform_id) !== Number(channel?.id))
        return 'Ответ связан с другим каналом. Выберите исходный канал или отмените ответ.'
    if (channel?.reply_supported !== true)
        return 'Ответ на сообщение недоступен в выбранном канале. Отмените ответ, чтобы отправить обычное сообщение.'
    return ''
}

export function messageReplySelection(message) {
    const target = messageReplyTarget(message)
    if (!target) return null
    return {
        ...target,
        sender_id: message.sender_id,
        sender_name: message.sender_name || message.operator_name || null,
        type: message.type,
        message: typeof message.message === 'string' ? message.message : '',
        caption: typeof message.caption === 'string' ? message.caption : null,
    }
}

export function replyQuoteText(reply) {
    if (!reply) return ''
    if (reply.type === 'media') return reply.caption ? `Вложение · ${reply.caption}` : 'Вложение'
    return typeof reply.message === 'string' && reply.message.trim() ? reply.message : 'Сообщение'
}
